// extracted by mini-css-extract-plugin
export var messageSideLeft = "_q1-1";
export var stateContainer = "_q1-0";